import { render, staticRenderFns } from "./appWeekSchedule.vue?vue&type=template&id=40faff2c&scoped=true"
import script from "./appWeekSchedule.vue?vue&type=script&lang=js"
export * from "./appWeekSchedule.vue?vue&type=script&lang=js"
import style0 from "./appWeekSchedule.vue?vue&type=style&index=0&id=40faff2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40faff2c",
  null
  
)

export default component.exports